import { useRef } from "react";
import type { AdminTenant } from "../api/types";

/**
 * Modale di selezione cliente per platform_admin.
 *
 * Mostrata solo alla primissima scelta in assoluto su questo browser (nessuna
 * scelta precedente salvata in localStorage). Ai login successivi la scelta
 * viene ricordata automaticamente — per cambiare cliente si usa il dropdown
 * in sidebar, non questa modale. Gli utenti di tenant normale non la vedono
 * mai (hanno già un tenant_id nel profilo). Niente backdrop-cancel né tasto
 * Annulla: è un gate obbligato, non un suggerimento.
 */
export function TenantPickerModal({
  tenants,
  onSelect,
}: {
  tenants: AdminTenant[];
  onSelect: (tenantId: string) => void;
}) {
  // Teniamo traccia del mousedown per evitare chiusura accidentale, ma qui
  // NON chiudiamo sul backdrop: il super admin DEVE scegliere un tenant.
  const backdropMouseDown = useRef(false);
  void backdropMouseDown; // pattern uniforme agli altri modal, ma senza cancel

  return (
    <div className="dialog-overlay">
      <div className="dialog-card" style={{ maxWidth: 520 }}>
        <div className="dialog-header">
          <div style={{ display: "flex", alignItems: "center", gap: "var(--space-3)" }}>
            <span
              className="material-symbols-outlined"
              style={{ color: "var(--indaco-brand-primary)", fontSize: 28 }}
            >
              apartment
            </span>
            <h2>Seleziona un cliente</h2>
          </div>
        </div>
        <div className="text-sm text-muted" style={{ marginBottom: "var(--space-5)" }}>
          Scegli a quale cliente accedere per questa sessione.
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-2)" }}>
          {tenants.map((t) => (
            <button
              key={t.tenant_id}
              className="flow-list-item"
              onClick={() => onSelect(t.tenant_id)}
            >
              <span
                className="material-symbols-outlined"
                style={{ color: "var(--indaco-brand-primary)", fontSize: 20 }}
              >
                apartment
              </span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span className="fw-semibold" style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {t.name}
                </span>
                {t.modules.length > 0 && (
                  <span className="text-xs text-muted" style={{ display: "block", marginTop: 2 }}>
                    {t.modules.join(" · ")}
                  </span>
                )}
              </span>
              <span
                className="material-symbols-outlined"
                style={{ color: "var(--indaco-gray-400)", fontSize: 20 }}
              >
                chevron_right
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
